import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration } from '@api/api-configuration';
import { Observable } from 'rxjs';

export interface ConsentResponse {
  surveyId: number;
  tid: string;
  token: string;
  url: string;
  survey: SurveyRow;
}

export interface SurveyRow {
  surveyKey: string | null;
  surveyType: string | null;
  status: string | null;
  sentDate: string | null;
  completeDate: string | null;
}

@Injectable({
  providedIn: 'root'
})
export class SurveysService {
  constructor(
    private http: HttpClient,
    private apiConfiguration: ApiConfiguration
  ) {}

  isEnabled(): Observable<boolean> {
    const rootUrl = this.apiConfiguration.rootUrl.replace(/\/$/, '');

    return this.http.get<boolean>(
      `${rootUrl}/api/Case/surveys/enabled`,
      {
        headers: {
          Accept: 'application/json'
        }
      }
    );
  }

  getSurveys(parentCaseKey: number): Observable<SurveyRow[]> {
    const rootUrl = this.apiConfiguration.rootUrl.replace(/\/$/, '');

    return this.http.get<SurveyRow[]>(
      `${rootUrl}/api/Case/${parentCaseKey}/surveys`,
      {
        headers: {
          Accept: 'application/json'
        }
      }
    );
  }

  requestConsent(
    parentCaseKey: number,
    userEmail: string
  ): Observable<ConsentResponse> {
    const rootUrl = this.apiConfiguration.rootUrl.replace(/\/$/, '');

    return this.http.post<ConsentResponse>(
      `${rootUrl}/api/Case/${parentCaseKey}/surveys/consent`,
      {
        userEmail
      },
      {
        headers: {
          Accept: 'application/json'
        }
      }
    );
  }
}